import { Autocomplete, TextField } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { getResCause } from 'src/shared/services/formSettingService';

// Utträdesorsak: kontrollerad, sökbar och avvalbar Autocomplete (samma UX som Land/Betalmetod).
// Värdet behålls som hela optionsobjektet {name, value} — memberDataGrid läser .value och chippen .name.
type ResCauseOption = { name: string; value: string };

export const MemberAdvancedSearchResCause = () => {
  const { control } = useFormContext();
  const isMounted = useIsMounted();
  const [options, setOptions] = useState<ResCauseOption[]>([]);

  useEffect(() => {
    (async () => {
      try {
        const result = await getResCause();
        if (isMounted()) {
          setOptions((result.data.results[0]?.extraOptions ?? []).filter((x) => x.name !== ''));
        }
      } catch (e) {
        if (isMounted()) ConsoleHelper.log(e);
      }
    })();
  }, [isMounted]);

  return (
    <Controller
      name='resCause'
      control={control}
      render={({ field }) => (
        <Autocomplete
          options={options}
          size='small'
          fullWidth
          getOptionLabel={(o) => o.name}
          isOptionEqualToValue={(o, v) => o.value === v.value}
          value={field.value || null}
          onChange={(_, newValue) => field.onChange(newValue || '')}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t('member:memberAdvancedSearch.resCause')}
              placeholder={t('common:form.all')}
              InputLabelProps={{ shrink: true }}
            />
          )}
        />
      )}
    />
  );
};
